import { computed } from 'vue'
import type { Implementation, ImplementationStatus, ImplementationType } from '@/types'
import type { ImplementationsState } from './state'

export const createGetters = (state: ImplementationsState) => {
  const filteredImplementations = computed(() => {
    let result = [...state.implementations]

    if (state.filters.search) {
      const search = state.filters.search.toLowerCase()
      result = result.filter(
        (app) =>
          app.name.toLowerCase().includes(search) ||
          app.description?.toLowerCase().includes(search)
      )
    }

    if (state.filters.projectId) {
      result = result.filter((app) => app.projectId === state.filters.projectId)
    }
    
    if (state.filters.applicationId) {
      result = result.filter((app) => app.applicationId === state.filters.applicationId)
    }

    if (state.filters.status) {
      result = result.filter((app) => app.status === state.filters.status)
    }

    if (state.filters.type) {
      result = result.filter((app) => app.type === state.filters.type)
    }

    return result
  })

  const implementationsByProject = computed(() => {
    const grouped: Record<string, Implementation[]> = {}
    filteredImplementations.value.forEach((app) => {
      if (!grouped[app.projectId]) {
        grouped[app.projectId] = []
      }
      grouped[app.projectId].push(app)
    })
    return grouped
  })
  
  const implementationsByApplication = computed(() => {
    const grouped: Record<string, Implementation[]> = {}
    filteredImplementations.value.forEach((app) => {
      if (app.applicationId) {
        if (!grouped[app.applicationId]) {
          grouped[app.applicationId] = []
        }
        grouped[app.applicationId].push(app)
      }
    })
    return grouped
  })

  const implementationsByStatus = computed(() => {
    const grouped: Record<string, Implementation[]> = {}
    state.implementations.forEach((app) => {
      if (!grouped[app.status]) {
        grouped[app.status] = []
      }
      grouped[app.status].push(app)
    })
    return grouped
  })

  const getImplementationsByProjectId = (projectId: string) =>
    computed(() => state.implementations.filter((a) => a.projectId === projectId))

  return {
    filteredImplementations,
    implementationsByProject,
    implementationsByApplication,
    implementationsByStatus,
    getImplementationsByProjectId,
  }
}
